// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-body-bg: #fcf9f5;
  --app-nav-text: #222222;
  --app-nav-muted: #919eab;
  --app-nav-hover: rgba(145, 158, 171, 0.08);
}

html,
body,
#root {
  background-color: var(--app-body-bg);
}

.app-admin-sidebar {
  background-color: #fff !important;
  border-right: none !important;
  box-shadow: 2px 0 10px -4px rgba(15, 23, 42, 0.08);
}

.app-sidebar-divider {
  border-top: 1px dashed #e5e7eb;
  margin: 0;
  flex-shrink: 0;
}

@keyframes sidebar-rocket-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.sidebar-rocket-float {
  animation: sidebar-rocket-float 2.6s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/theme/app-shell.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,yDAAyD;AAC3D","sourcesContent":[":root {\n  --app-body-bg: #fcf9f5;\n  --app-nav-text: #222222;\n  --app-nav-muted: #919eab;\n  --app-nav-hover: rgba(145, 158, 171, 0.08);\n}\n\nhtml,\nbody,\n#root {\n  background-color: var(--app-body-bg);\n}\n\n.app-admin-sidebar {\n  background-color: #fff !important;\n  border-right: none !important;\n  box-shadow: 2px 0 10px -4px rgba(15, 23, 42, 0.08);\n}\n\n.app-sidebar-divider {\n  border-top: 1px dashed #e5e7eb;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n@keyframes sidebar-rocket-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.sidebar-rocket-float {\n  animation: sidebar-rocket-float 2.6s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
